export default __webpack_public_path__ + "../css/dbk-cookie-law.css";